import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=77b2d16f&scoped=true&"
import script from "./NewPassword.js?vue&type=script&lang=js&"
export * from "./NewPassword.js?vue&type=script&lang=js&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=77b2d16f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2d16f",
  null
  
)

export default component.exports